import React, { useCallback } from 'react'
import { Text } from '@usap/uicomponents'
import {
  OrderESPPContainer,
  OrderESPPFrame,
  OrderItemESPPBox,
  OrderESPPDivider,
  OrderESPPButtonContainer,
  OrderESPPDetailsButtonContainer,
  OrderESPPDetailsClaimButton,
  OrderESPPImageContainer,
  OrderESPPImage,
  OrderDetailESPPContainer,
  OrderESPPTitle,
  OrderESPPExtendPackage,
  OrderESPPSpan,
  OrderESPPTextWrapper2,
  OrderESPPLabelSkuInfoWrapper,
  OrderESPPLabelSkuInfo,
  OrderESPPTextWrapper3,
  OrderESPPTextWrapper4,
  OrderESPPParagraph,
} from './OrderESPP.css'

export default function OrderESPP({
  isESPP,
  eSPPAmount,
  GTM,
  orderDetails,
}) {
  const shippingProtectionAmount = parseFloat(orderDetails?.shippingProtection?.amount)
  const orderTotal = parseFloat(orderDetails?.orderSummary?.total)
  const partNames = orderDetails?.shippingProtection?.partNames
  const state = orderDetails?.shipping?.address?.state
  const zipCode = orderDetails?.shipping?.address?.postcode

  const claimButton = useCallback(() => {
    GTM.shippingProtectionOrderDetailsStartClaim(shippingProtectionAmount, orderTotal, partNames, state, zipCode)
    window.open('https://customers.extend.com/?_ga=2.256293581.755696520.1709767054-267081616.1708114875', '_blank')
  }, [GTM, orderTotal, partNames, shippingProtectionAmount, state, zipCode])

  if (!isESPP) {
    return null
  }

  return (
    <>
      <OrderESPPContainer data-testid="myaccount-order-details-espp-widget">
        <OrderESPPFrame wrap>
          <OrderItemESPPBox>
            <OrderESPPImageContainer>
              <OrderESPPImage src="https://cld.partsimg.com/image/upload/v1710465399/carparts/shipping-protection/extend-shipping-claim.jpg" />
            </OrderESPPImageContainer>
            <OrderDetailESPPContainer>
              <OrderESPPTitle>
                <OrderESPPExtendPackage>
                  <OrderESPPSpan>EXTEND </OrderESPPSpan>
                  <OrderESPPTextWrapper2>Shipping Protection</OrderESPPTextWrapper2>
                </OrderESPPExtendPackage>
              </OrderESPPTitle>
              <OrderESPPLabelSkuInfoWrapper>
                <OrderESPPLabelSkuInfo>
                  <OrderESPPTextWrapper3>Item Total: </OrderESPPTextWrapper3>
                  <OrderESPPTextWrapper4>{`$${eSPPAmount}`}</OrderESPPTextWrapper4>
                </OrderESPPLabelSkuInfo>
              </OrderESPPLabelSkuInfoWrapper>
              <OrderESPPParagraph>
                If your order is lost, stolen or damaged, activate your protection by starting a claim.
              </OrderESPPParagraph>
            </OrderDetailESPPContainer>
          </OrderItemESPPBox>
          <OrderESPPDivider />
          <OrderESPPButtonContainer gap="small" data-testid="myaccount-order-details-espp-cta-claim">
            <OrderESPPDetailsButtonContainer>
              <OrderESPPDetailsClaimButton
                custom
                hideBorder
                label={<Text size="15px" color="dark-2">Start Shipping Protection Claim</Text>}
                onClick={claimButton}
              />
            </OrderESPPDetailsButtonContainer>
          </OrderESPPButtonContainer>
        </OrderESPPFrame>
      </OrderESPPContainer>
    </>
  )
}
